module.exports = __webpack_public_path__ + "static/img/1.7fc89f8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Images/1.jpg
// module id = e+CF
// module chunks = 0